<template>
  <div>
    <div class="element">
      <GetScore v-bind:SampleInfo="sepaMethods.SampleInfo"></GetScore>
      <div class="titleStyle">样品信息</div>
      <GetOriginSample v-bind:SampleInfo="sepaMethods.SampleInfo" v-bind:startObjects="sepaMethods.startObjects"></GetOriginSample>
    </div>
    <div class="element">
      <div class="titleStyle">原始样品分析与鉴定</div>
              <GetOrginMethods v-bind:form="sepaMethods.sampleAnalysis"
                                  v-bind:GradientList="sepaMethods.GradientList"
                                  v-bind:RFList="sepaMethods.RFList"
                                  v-bind:RTList="sepaMethods.RTList"
                                  v-bind:SolventList="sepaMethods.SolventList"></GetOrginMethods>
    </div>
    <div class="element">
      <div class="titleStyle">分离参数</div>
                  <GetMethodInfo v-bind:MethodInfo="sepaMethods.MethodInfo"
                                  v-bind:GradientList="sepaMethods.GradientList"
                                  v-bind:FlowRateList="sepaMethods.FlowRateList"
                                  v-bind:IsFour="sepaMethods.IsFour"
                                  v-bind:Chromatographic="sepaMethods.Chromatographic"></GetMethodInfo>
    </div>
    <div class="element" >
      <div class="titleStyle">纯度及结果认定</div>
                  <GetResCondition v-bind:form="sepaMethods.purityResConfirmation"></GetResCondition>
    </div>
    <div class="element" style="min-height: 300px;">
      <div class="titleStyle" >综合评价</div>
                  <GetEvaluation v-bind:textSet="sepaMethods.EvaluateSet"></GetEvaluation>
    </div>
    <div class="element" style="min-height: 900px;">
      <div class="titleStyle">仪器信息</div>
                  <GetMachineInfo v-bind:machineInfo="sepaMethods.MachineInfo"></GetMachineInfo>
    </div>
  <div class="sidebar">
        <div :class="{ active: active == 0 }" @click="scrollTo(0)">样品信息</div>
        <div :class="{ active: active == 1 }" @click="scrollTo(1)">原始样品分析与鉴定</div>
        <div :class="{ active: active == 2 }" @click="scrollTo(2)">分离参数</div>
        <div :class="{ active: active == 3 }" @click="scrollTo(3)">纯度及结果认定</div>
        <div :class="{ active: active == 4 }" @click="scrollTo(4)">综合评价</div>
        <div :class="{ active: active == 5 }" @click="scrollTo(5)">仪器信息</div>
    </div>
  </div>
</template>
<script>
import GetScore from './GetScore'
import GetOrginMethods from './GetOriginMethods'
import GetOriginSample from './GetOriginSample'
import GetMethodInfo from './GetMethodInfo'
import GetResCondition from './GetResCondition'
import GetEvaluation from './GetEvaluation'
import GetMachineInfo from './GetMachineInfo'
export default {
  name: "SearchMethodsDetail",
  components: {
              GetScore,
              GetOrginMethods,
              GetOriginSample,
              GetMethodInfo,
              GetResCondition,
              GetEvaluation,
              GetMachineInfo
          },
          props: {
              sepaMethods: {}
          },
  data() {
    return {
      active: 0, // 当前激活的导航索引
      observer: null
    }
  },
  created() {},
  mounted() {
      // 监听滚动事件
      window.addEventListener('scroll', this.onScroll, false)
    },
    destroy() {
      // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
      window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
 // 滚动监听器
/**
 * 监听页面滚动事件
 * 该方法用于根据滚动位置动态激活导航项。
 * 它通过比较滚动位置和页面中各个锚点的位置，来确定当前应该激活的导航项。
 */
onScroll() {
  // 获取所有锚点元素
  const navContents = document.querySelectorAll('.element')
  // 收集所有锚点元素的顶部偏移量
  // 所有锚点元素的 offsetTop
  const offsetTopArr = []
  navContents.forEach((item) => {
    offsetTopArr.push(item.offsetTop)
  })
  // 获取当前滚动位置
  // 获取当前文档流的 scrollTop
  let scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop || 0
  // 初始化当前激活的导航项索引
  // 定义当前点亮的导航下标
  let navIndex = 0
  
  // 遍历锚点元素的顶部偏移量数组，以确定当前激活的导航项
  for (let n = 0; n < offsetTopArr.length; n++) {
    // 如果滚动位置大于等于当前锚点元素的顶部偏移量，则更新激活的导航项索引
    // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
    // 那么此时导航索引就应该是n了
    if (scrollTop >= offsetTopArr[n]) {
      navIndex = n
    }
    // 如果滚动到底部，将激活最后一个导航项
    if (
      scrollTop + document.documentElement.clientHeight ===
      document.documentElement.scrollHeight
    ) {
      navIndex = offsetTopArr.length - 1
    }
  }
  // 更新当前激活的导航项
  this.active = navIndex
},
      // 跳转到指定索引的元素
            /**
       * 平滑滚动到页面中的指定元素
       * @param {number} index - 目标元素的索引，用于定位元素
       */
      scrollTo(index) {
        // 获取目标元素在页面中的顶部偏移量
        // 获取目标的 offsetTop
        // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
        const targetOffsetTop = document.querySelector(
          `.element:nth-child(${index+1})`
        ).offsetTop
        
        // 获取当前页面的滚动位置
        // 获取当前 offsetTop
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop

        // 定义每次滚动的步长
        const STEP = 50

        // 判断当前滚动位置是否在目标元素之上，如果是，则向下滚动，否则向上滚动
        // 判断是往下滑还是往上滑
        if (scrollTop > targetOffsetTop) {
          // 往上滑
          smoothUp()
        } else {
          // 往下滑
          smoothDown()
        }

        // 平滑向下滚动的函数
        // 定义往下滑函数
        function smoothDown() {
          // 如果当前滚动位置还未到达目标元素顶部，则继续滚动
          // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
          if (scrollTop < targetOffsetTop) {
            // 如果与目标位置的距离大于等于STEP，则滚动STEP，否则直接滚动到目标位置
            // 如果和目标相差距离大于等于 STEP 就跳 STEP
            // 否则直接跳到目标点，目标是为了防止跳过了。
            if (targetOffsetTop - scrollTop >= STEP) {
              scrollTop += STEP
            } else {
              scrollTop = targetOffsetTop
            }
            // 设置页面滚动位置
            document.body.scrollTop = scrollTop
            document.documentElement.scrollTop = scrollTop
            // 通过requestAnimationFrame递归调用自身，实现平滑滚动
            // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
            requestAnimationFrame(smoothDown)
          }
        }

        // 平滑向上滚动的函数
        // 定义往上滑函数
        function smoothUp() {
          // 如果当前滚动位置在目标元素顶部之下，则继续滚动
          if (scrollTop > targetOffsetTop) {
            // 如果与目标位置的距离大于等于STEP，则滚动STEP，否则直接滚动到目标位置
            if (scrollTop - targetOffsetTop >= STEP) {
              scrollTop -= STEP
            } else {
              scrollTop = targetOffsetTop
            }
            // 设置页面滚动位置
            document.body.scrollTop = scrollTop
            document.documentElement.scrollTop = scrollTop
            // 通过requestAnimationFrame递归调用自身，实现平滑滚动
            requestAnimationFrame(smoothUp)
          }
        }
      },
  }
}
</script>
<style scoped >
.sidebar{
  position: fixed;
    right: 100px;
    width: 250px;
    overflow: auto;
    color: #c9c9c9;
    height: auto;
    top: 168px;
    font-size: 25px;
    cursor: pointer
}
.sidebar div{
  padding: 4px 0 6px 8px;
  box-sizing: border-box;
  border-left: 1px solid #d1d1d1;
}
.active{
  color: #409eff;
}
.titleStyle{
    font-size: 17px;
  font-weight: 600;
  box-sizing: border-box;
  border-left: 6px solid #58aaff;
  padding: 0 0 0 10px;
  margin: 24px 0 5px 0;
  }
</style>
